import React, { useCallback, useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import AdminSubpage from '../components/AdminSubpage';
import ProductDetails from '../components/ProductDetails';
import { productsAPI } from '../services/api';
import { isInfluencerUser } from '../utils/auth';

const getDisplayStatus = (product) => {
  const status = (product?.status || 'default').toLowerCase();
  const expiresAt = product?.expires_at ? new Date(product.expires_at) : null;
  const isExpired = !!(
    expiresAt &&
    !Number.isNaN(expiresAt.getTime()) &&
    expiresAt < new Date() &&
    status !== 'sold' &&
    status !== 'rejected'
  );
  return isExpired ? 'expired' : status;
};

const ProductDetailPage = () => {
  const { productId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const backTo = location.state?.backTo || '/products';
  const [product, setProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  const readOnly = isInfluencerUser();

  const load = useCallback(async () => {
    if (!productId) return;
    setLoading(true);
    try {
      const response = await productsAPI.getById(productId);
      setProduct(response.data);
    } catch (error) {
      toast.error(
        'Error loading product: ' + (error.response?.data?.message || error.message)
      );
      setProduct(null);
    } finally {
      setLoading(false);
    }
  }, [productId]);

  useEffect(() => {
    void load();
  }, [load]);

  const pid = product?.id || product?.uuid;
  const displayStatus = product ? getDisplayStatus(product) : '';
  const title = product?.title ? product.title : 'Product';

  const editState = {
    ...location.state,
    backTo: backTo,
  };

  return (
    <AdminSubpage
      title={title}
      backTo={backTo}
      titleExtra={
        product && displayStatus ? (
          <span className={`status-badge status-${displayStatus}`}>{displayStatus}</span>
        ) : null
      }
    >
      {loading ? (
        <div className="loading">Loading product…</div>
      ) : product ? (
        <ProductDetails
          product={product}
          readOnly={readOnly}
          onEdit={
            readOnly || !pid
              ? undefined
              : () =>
                  navigate(`/products/${pid}/edit`, {
                    state: editState,
                  })
          }
        />
      ) : (
        <p>Product not found.</p>
      )}
    </AdminSubpage>
  );
};

export default ProductDetailPage;
